const numberWithCommas = (x) => {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return x.toString().replace(pattern, ",");
}

function getRandomNumber(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

export {
    getRandomNumber,
    numberWithCommas
}